import logo from './Technology.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <br/>
        <br/>
        <p>
          Welcome to n8eye200.cloud!
        </p>
        <p>
          Not much here yet...  Stay tuned!
        </p>
      </header>
    </div>
  );
}

export default App;
